import MockExamDataCard from './MockExamDataCard';

export default MockExamDataCard;
